var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,8.9L16,9.7V6L8.4,1.6L0.8,6v8.8l7.6,4.4l3.1-1.8V19l5.8,3.3l5.8-3.3v-6.8L17.3,8.9z M17.3,10l4.3,2.5 l-4.3,2.5L16,14.3l-1-0.6l-2-1.2l2-1.2l1-0.6L17.3,10z M7.9,17.7l-6.1-3.5V7.1l6.1,3.5V17.7z M2.3,6.3l6.1-3.5l6.1,3.5L8.4,9.8 L2.3,6.3z M11.5,16.2l-2.6,1.5v-7L15,7.1v3.1l-3.5,2V16.2z M12.5,13.4l1.9,1.1l1,0.6l1.4,0.8v5l-4.3-2.5V13.4z M22.2,18.5l-4.3,2.5 v-5l4.3-2.5V18.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLot);
export default __webpack_public_path__ + "static/media/icon-lot.fb0f1c0eeff6dd6fed2b1d883afc472c.svg";
export { ForwardRef as ReactComponent };